import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('shares', { routeName: 'frontdoorResourceRoute' })
export class Namespace extends Resource {
    namespace: string;
    description: any;
    selected = false;
    id: string;
    token: string;
    name: string;
    status: string;
    default: boolean;
}